<script>
  import { push } from "svelte-spa-router";
  import { loggedInUserStore } from "../store/loggedInUser.js";
  import { factoryStore } from "../store/factories.js";
  import { langTextStore } from "../store/langtexts.js";
  import FactoryList from "./FactoryList.svelte";
  import LangSelector from "../SharedComponents/LangSelector.svelte";
  import ProductList from "./ProductList.svelte";
  export let params = { sectionName: "products" };
  import IconChevronRight from "../Vectors/chevronright.svelte";
  import IconEye from "../Vectors/eye.svelte";
  $: loggedInEmail = $loggedInUserStore.email;

  async function logout() {
    await loggedInUserStore.logout();
    loggedInUserStore.setLoginNeeded();
    push("/");
  }

  async function viewTour() {
    await loggedInUserStore.seenTourNo();
  }
  var modereturnText = "";
  async function setMode() {
    var mode = $factoryStore.onlinemode == "online" ? "offline" : "online";
    var ret = await factoryStore.setMode(mode);
    if (ret !== undefined && ret !== null) {
      modereturnText = "<p style='color: #ed003b'>" + ret + "</p>";
      setTimeout(() => {
        modereturnText = "";
      }, 2000);
    }
  }
  $: onoffline = $factoryStore.onlinemode === "online" ? true : false;

  async function sync(alertWhenError = true) {
    if ($factoryStore.onlinemode === "online") {
      try {
        var succeeded = await factoryStore.syncall();
        if (succeeded == true) {
          await factoryStore.syncget();
        } else {
          if (succeeded != "offline" && alertWhenError) alert("sync failed");
        }
      } catch (s) {
        if (alertWhenError) alert("sync failed" + s);
      }
    }
  }
  sync(false);
</script>

<svelte:head>
  <style>
    body {
      background: #fff;
    }

    .switcher-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      color: #fff;
    }
    body span.switcher {
      position: relative;
      width: 200px;
      height: 44px;
      border-radius: 25px;
      margin: 20px 0;
    }
    body span.switcher input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      position: relative;
      width: 100%;
      height: 38px;
      border-radius: 22px;
      background-color: #ed003b;
      outline: none;
      font-family: "Oswald", sans-serif;
    }
    body span.switcher .switcher-online,
    body span.switcher .switcher-offline {
      z-index: 2;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: #ffffff;
      pointer-events: none
    }
    body span.switcher .switcher-online {
            left: 20px;
    }
    body span.switcher .switcher-offline {
      right: 20px;
    }
    body span.switcher label {
      z-index: 1;
      position: absolute;
      top: 10px;
      bottom: 10px;
      border-radius: 20px;
      width: unset;
      margin-bottom: 0;
    }
    body span.switcher.switcher-1 input {
      transition: 0.25s -0.1s;
    }
    body span.switcher.switcher-1 input:checked {
      background-color: #ffffff;
    }
    body span.switcher.switcher-1.online .switcher-online {
      color: #ffffff;
      transition: color 0.5s 0.2s;
    }
    body span.switcher.switcher-1.online .switcher-offline {
      color: #cccccc;
      transition: color 0.5s;
    }
    body span.switcher.switcher-1 input:checked + label {
      left: 10px;
      right: 100px;
      background: #ed003b;
      transition: left 0.5s, right 0.4s 0.2s;
    }
    body span.switcher.switcher-1 input:not(:checked) {
      background: #ed003b;
      transition: background 0.5s -0.1s;
    }
    body span.switcher.switcher-1.offline .switcher-online {
      color: #cccccc;
      transition: color 0.5s;
    }
    body span.switcher.switcher-1.offline .switcher-offline {
      color: #ed003b;
      transition: color 0.5s 0.2s;
    }
    body span.switcher.switcher-1 input:not(:checked) + label {
      left: 100px;
      right: 10px;
      background: #ffffff;
      transition: left 0.4s 0.2s, right 0.5s, background 0.35s -0.1s;
    }
    body span.switcher.switcher-2 {
      overflow: hidden;
    }
    body span.switcher.switcher-2 input {
      transition: background-color 0s 0.5s;
    }
    body span.switcher.switcher-2 input:before {
      color: #ed003b;
    }
    body span.switcher.switcher-2 input:after {
      color: #ffffff;
    }
    body span.switcher.switcher-2 input:checked {
      background-color: #ffffff;
    }
    body span.switcher.switcher-2 input:checked + label {
      background: #ffffff;
      -webkit-animation: turn-on 0.5s ease-out;
      animation: turn-on 0.5s ease-out;
    }
    @-webkit-keyframes turn-on {
      0% {
        left: 100%;
      }
      100% {
        left: 0%;
      }
    }
    @keyframes turn-on {
      0% {
        left: 100%;
      }
      100% {
        left: 0%;
      }
    }
    body span.switcher.switcher-2 input:not(:checked) {
      background: #1e1e1e;
    }
    body span.switcher.switcher-2 input:not(:checked) + label {
      background: #1e1e1e;
      -webkit-animation: turn-off 0.5s ease-out;
      animation: turn-off 0.5s ease-out;
    }
    @-webkit-keyframes turn-off {
      0% {
        right: 100%;
      }
      100% {
        right: 0%;
      }
    }
    @keyframes turn-off {
      0% {
        right: 100%;
      }
      100% {
        right: 0%;
      }
    }
    body span.switcher.switcher-2 label {
      top: 0px;
      width: 200px;
      height: 37px;
      border-radius: 25px;
    }
  </style>
</svelte:head>
<LangSelector
  extraClass="lang-switcher-dashboard"
  langs={$langTextStore.allLangs}
  showChoice={false}
  on:langChosen={() => {}}
/>
<div id="dashboard" class="container-fluid">
  <div class="row">
    <div
      class="col-12 col-md-4 p-0  col-lg-3 col-xl-2 bg-gray-3 dashboard--left"
    >
      <div id="logo-container">
        <img
          src="/img/logo.svg"
          id="logo"
          class="w-md-100 w-100 "
          alt={$langTextStore.getText("general-label-app-title")}
          title={$langTextStore.getText("general-label-app-title")}
        />
      </div>
      <div class="vh-100 position-relative">
        <div id="logout" style="margin-bottom:140px; width:200px">
          <div class="switcher-container ms-3 me-3">
            {$langTextStore.getText("general-onlinemode-working-offline-mode")}
            {@html modereturnText}
            <span class="switcher switcher-1 {$factoryStore.onlinemode}">
              <span class="switcher-online">{$langTextStore.getText("general-online")}</span>
              <input
                type="checkbox"
                bind:checked={onoffline}
                on:click={() => setMode()}
                id="switcher-1"
              />
              <label for="switcher-1" />
              <span class="switcher-offline">{$langTextStore.getText("general-offline")}</span>
            </span>
          </div>
        </div>
        <div id="logout" class="text-small ps-3">
          <div class="c-pointer" on:click={viewTour}>
            <IconEye />&nbsp;{$langTextStore.getText("general-label-view-tour")}
          </div>
          <br /><br />
          <span class="font-weight-bold font-primary">{loggedInEmail}</span>
          <div class="c-pointer mt-2 " on:click={logout}>
            {$langTextStore.getText("general-label-logout")}<IconChevronRight />
          </div>
        </div>
      </div>
    </div>
    <div class=" col-12 col-md-8 col-lg-9 col-xl-10 g-0">
      <!--#1 MOET ANDERS en in component of iets dergelijks-->
      <div class="row navigator navigator--light g-0 mt-3 mb-5">
        <a
          href="#/dashboard/factories"
          class="navigator__item  {params.sectionName === 'factories'
            ? 'active'
            : ''} "
          >{$langTextStore.getText("general-label-factory-settings")}</a
        >
        <a
          href="#/dashboard/products"
          class="navigator__item {params.sectionName !== 'factories'
            ? 'active'
            : ''} "
          >{$langTextStore.getText("general-label-product-calculations")}</a
        >
      </div>

      <!-- end anders -->
      {#if !$factoryStore.isBusySync}
        {#if params.sectionName == "factories"}
          <FactoryList />
        {:else}
          <ProductList />
        {/if}
      {/if}
    </div>
  </div>
</div>
